export default __webpack_public_path__ + "static/media/CL.f19e05ca.svg";